import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';

import DesktopLayout from '@/layout/DesktopLayout.vue';
import MobileLayout from '@/layout/MobileLayout.vue';
import useCommonStore from '@/store/storeCommon';



export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { isMobile } = storeToRefs(useCommonStore());
const { windowSize } = useCommonStore();

onMounted(() => {
  window.addEventListener('resize', () => {
    onWindowResize();
  });
  const accessInfo = navigator.userAgent;
  if (
    accessInfo.indexOf('iPhone') > -1 ||
    accessInfo.indexOf('Android') > -1 ||
    accessInfo.indexOf('iPad') > -1 ||
    accessInfo.indexOf('iPod') > -1 ||
    (accessInfo.includes('Mac OS') && navigator.maxTouchPoints > 1)
  ) {
    isMobile.value = true;
  } else {
    isMobile.value = false;
  }
});

/**
 * 윈도우 가로, 세로 사이즈를 감지합니다.
 */
const onWindowResize = (): void => {
  windowSize.width = window.innerWidth;
  windowSize.height = window.innerHeight;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(isMobile) && ((_unref(windowSize).width > 1280 && _unref(windowSize).height > 800) || (_unref(windowSize).width > 800 && _unref(windowSize).height > 1280)))
      ? (_openBlock(), _createBlock(DesktopLayout, { key: 0 }))
      : (_openBlock(), _createBlock(MobileLayout, { key: 1 })),
    _createVNode(_component_router_view)
  ]))
}
}

})